import React, { ReactNode } from 'react';

interface Props {
  isLoading: boolean,
  error?: unknown,
  // undefined children means the query has no data to render yet
  children?: ReactNode,
}

const QueryStatus = ({ isLoading, error, children }: Props) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center">
        <div
          className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          role="status">
          <span
            className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"
          >
            Loading...
          </span>
        </div>
      </div>
    );
  }

  if (error || children === undefined) {
    return <div>There was an error.</div>;
  }

  return <>{children}</>;
};

export default QueryStatus;
